import React from 'react';
import _ from 'lodash';
import { generateTimeId} from 'common/utils';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {DEFAULT_CONFIG, MODES} from 'common/requestDetails/constants.js';
import {toItemCode} from 'common/requestDetails/utils';
import ItemDispatch from 'go/components/modules/requestDetails/v3/ItemDispatch';
import {Contexts} from 'componentLibrary';
const {RequestDetailsContext} = Contexts;

export class AddItemModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: {},
      disabledButton: true
    };
  }

  static contextType = RequestDetailsContext;

  static defaultProps = {
    parentConfigToMerge: {},
  };

  componentDidMount() {
    this.setState({
      disabledButton: true,
    });
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.active && this.props.active) {
      this.initialize();
    }
  }

  getFirstItemCode = () => {
    // actually first non-0-valued itemCode, since first choice is sometimes a "Plese select a value" type choice with value of 0
    const nonZeroItemCodeOption = _.find(this.props.itemCodeOptions, (o) => _.get(o, 'value', 0) != 0 )
    return toItemCode(_.get(nonZeroItemCodeOption, 'value'));
  };

  handleBlur = (pathToIgnore, itemData) => {
    this.setState({
      itemData,
      disabledButton: itemData.itemCode === 0 ? true : false,
    });
  };

  addDefaultValue = (options) => {
    if (options && options.length > 0 && options[0]) {
      if (_.toLower(_.get(options, [0, 'text'], '')) !== 'select') {
        let selectItem = {
          text: 'Select',
          value: '0',
          key: '0',
        };
        options.splice(0, 0, selectItem);
      }
    }
    return options;
  };

  initialize = () => {
    const {eligibleChildren} = this.props;
    const mode = _.get(this.context, 'mode');
    const firstEligibleItemCode = this.getFirstItemCode();
    const {itemData} = this.state;
    const toAddConfig = _.find(
      eligibleChildren,
      (child) => child.itemCode === firstEligibleItemCode
    );
    const defaultLabel = firstEligibleItemCode === 8 ? 'item' : 'sub-category';
    const itemLabel = _.upperFirst(_.get(toAddConfig, 'labels.itemLabel', defaultLabel));
    const additionalInformation =
      mode === MODES.APPLICATION
        ? {}
        : {
            changes: [
              {
                displayText: itemLabel,
                type: 'newlyCreated',
              },
            ],
          };
    
    this.setState({
      itemData: {
        itemCode: 0,
        additionalInformation,
      },
      disabledButton: itemData.itemCode === 0,

    });
  };

  cancel = () => {
    this.props.cancelAction();
    this.initialize();
  };

  render() {
    const {
      active,
      saveItem,
      mode,
      eligibleChildren,
      parentConfigToMerge,
      displayFields,
      itemCodeOptions
    } = this.props;
    const {itemData} = this.state;

    const selectedItemCode = _.get(itemData, 'itemCode', 0);
    let toAddConfig = _.find(
      eligibleChildren,
      (child) => child.itemCode === selectedItemCode
    );

    if (!toAddConfig) {
      // get just the label from first eligible child
      toAddConfig = {labels: _.get(eligibleChildren, [0, 'labels'], '')};
    }

    toAddConfig = {
      ...parentConfigToMerge,
      additionalQuestions: _.get(parentConfigToMerge, 'additionalQuestions.allChildren'),
      ...DEFAULT_CONFIG,
      ...toAddConfig,
    };
    const itemLabel = _.get(toAddConfig, 'labels.itemLabel', 'item');
    return (
      <FemaGoModal
        size="large"
        title={`Add ${_.lowerCase(_.get(toAddConfig, 'labels.itemDisplayText', `a ${itemLabel}`))}`}
        open={active}
        confirmAction={() => {
          saveItem(`${generateTimeId()}`, itemData);
          this.cancel(); // close modal
        }}
        buttonText={`Add this ${itemLabel}`}
        disableButton={this.state.disabledButton}
        cancelAction={this.cancel}
      >
        {active && itemData.itemCode !== undefined && (
          <ItemDispatch
            itemConfig={toAddConfig}
            itemCodeOptions={this.addDefaultValue(itemCodeOptions)}
            item={itemData}
            editable={true}
            saveItem={this.handleBlur}
            beingCreated={true}
            displayFields={displayFields}
            mode={mode}
          />
        )}
      </FemaGoModal>
    );
  }
}

export default AddItemModal;
